import { render } from "./DrawLog.vue?vue&type=template&id=4564d712"
import script from "./DrawLog.vue?vue&type=script&lang=js"
export * from "./DrawLog.vue?vue&type=script&lang=js"

import "./DrawLog.vue?vue&type=style&index=0&id=4564d712&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__